exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dyna-travel-imHoliday-product-logo .dyna-svg-defaults {\n  width: inherit;\n  height: inherit;\n}\n", ""]);

// exports
